import { Component } from '@angular/core';

@Component({
  selector: 'happy-heading',
  templateUrl: './happy-heading.component.html',
  styleUrls: ['./happy-heading.component.css']
})
export class HappyHeadingComponent {
}



// WEBPACK FOOTER //
// ./src/app/shared/components/happy/happy-heading/happy-heading.component.ts